var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0925 15.2L7.44141 12.8V30.5336C7.44141 31.3435 8.05212 32 8.80549 32H30.6353C31.3887 32 31.9994 31.3435 31.9994 30.5336V24L20.0925 15.2Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0925 0H8.80549C8.05212 0 7.44141 0.656526 7.44141 1.4664V8L20.0925 16L26.7901 18.4L31.9994 16V8L20.0925 0Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44141 8H20.0925V16H7.44141V8Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.4959 6.39996H7.44141V26.4H16.4959C17.2482 26.3973 17.8575 25.7423 17.86 24.9336V7.86636C17.8575 7.05759 17.2482 6.40259 16.4959 6.39996Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.7517 7.20001H7.44141V27.2H15.7517C16.504 27.1974 17.1133 26.5424 17.1158 25.7336V8.66641C17.1133 7.85763 16.504 7.20264 15.7517 7.20001Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.7517 7.20001H7.44141V25.6H15.7517C16.504 25.5974 17.1133 24.9424 17.1158 24.1336V8.66641C17.1133 7.85763 16.504 7.20264 15.7517 7.20001Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.0075 7.20001H7.44141V25.6H15.0075C15.7599 25.5974 16.3692 24.9424 16.3716 24.1336V8.66641C16.3692 7.85763 15.7599 7.20264 15.0075 7.20001Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36408 7.20001H15.0079C15.7613 7.20001 16.372 7.85654 16.372 8.66641V23.3336C16.372 24.1435 15.7613 24.8 15.0079 24.8H1.36408C0.610719 24.8 0 24.1435 0 23.3336V8.66641C0 7.85654 0.610719 7.20001 1.36408 7.20001Z",
    fill: "url(#paint0_linear_11709_8338)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22461 20.7665L7.09418 15.9865L4.46498 11.2328H6.57994L8.01473 14.2728C8.1472 14.5616 8.23798 14.776 8.28711 14.9176H8.30571C8.39846 14.6907 8.49773 14.4668 8.60338 14.2464L10.1371 11.2345H12.0787L9.38253 15.9601L12.1472 20.7664H10.0813L8.42403 17.4297C8.34597 17.2877 8.27973 17.1386 8.22609 16.9841H8.20153C8.15299 17.1354 8.08857 17.2804 8.00953 17.4161L6.30312 20.7665H4.22461Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6356 0H20.0928V8H31.9997V1.4664C31.9997 0.656526 31.389 0 30.6356 0Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0928 16H31.9997V24H20.0928V16Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11709_8338",
    x1: 2.84415,
    y1: 6.0542,
    x2: 14.7282,
    y2: 25.2008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.26d16b11594f61aea6cb138f8369b8ec.svg";
export { ForwardRef as ReactComponent };